import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getIntegrations } from '../../../redux/integration/actions';
import { setAlert } from '../../../redux/dashboard/actions';
import { getSelectedCompany, selectCompany } from '../../../redux/company/actions';

import CustomCheckBox from '../../../components/customCheckBox';
import CustomButton from '../../../components/customButton';

import API from '../../../services/api';

import utils from '../../../utils';

const IntegrationTab = () => {
  const [initialActiveIntegrations, setInitialActiveIntegrations] = useState([]);
  const [activeIntegrations, setActiveIntegrations] = useState([]);

  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const integrations = useSelector(getIntegrations);
  const company = useSelector(getSelectedCompany);

  const dispatch = useDispatch();

  useEffect(() => {
    setActiveIntegrations(company.enabledCmsIntegrations);
    setInitialActiveIntegrations(company.enabledCmsIntegrations);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    setIsSaveButtonEnabled(!utils.compareArrays(activeIntegrations, initialActiveIntegrations));
  }, [activeIntegrations]);

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const res = await API.updateCompany({ ...company, enabledIntegrations: activeIntegrations }, [
        'enabledCmsIntegrations'
      ]);
      dispatch(selectCompany(res));
      dispatch(setAlert(utils.generateAlert('Changes on integrations were applied!', 'success')));
    } catch (error) {
      console.error(error);
      dispatch(setAlert(utils.generateAlert('Error on saving your settings. Try again later!', 'error')));
    } finally {
      setIsLoading(false);
    }
  };

  const handleIntegrationSelection = (add, integration) => {
    let localIntegrations = [...activeIntegrations];
    if (add) {
      localIntegrations.push(integration.vendor);
    } else {
      localIntegrations = localIntegrations.filter(i => i !== integration.vendor);
    }
    setActiveIntegrations(localIntegrations);
  };

  const renderIntegrationName = integrationName => {
    if (!integrationName) return '';
    return integrationName.charAt(0).toUpperCase() + integrationName.slice(1).toLowerCase();
  };

  return (
    <>
      <h2>Activate integrations</h2>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="integration-list">
            {integrations.map(integration => {
              const isSelected = activeIntegrations.includes(integration.vendor) ? 'all' : 'none';

              return (
                <CustomCheckBox
                  key={integration.vendor}
                  label={renderIntegrationName(integration.vendor)}
                  selected={isSelected}
                  onClick={status => handleIntegrationSelection(!status, integration)}
                />
              );
            })}
          </div>
          <div className="horizontal-separator" />
          <div className="form-row justify-content-end">
            <CustomButton
              classes="btn-danger left-button"
              title="Cancel"
              handleClick={() => setActiveIntegrations(initialActiveIntegrations)}
            />
            <CustomButton
              classes="btn-secondary"
              title="Save"
              handleClick={handleSave}
              disabled={!isSaveButtonEnabled}
            />
          </div>
        </>
      )}
    </>
  );
};

export default IntegrationTab;
